export default "__VITE_ASSET__BQ8CE0W___"